/**
 * Centralized Cryptocurrency Icon Configuration
 * 
 * This file is auto-generated from shared/coins.config.js
 * DO NOT EDIT THIS FILE DIRECTLY - make changes in shared/coins.config.js instead
 * 
 * This file manages all cryptocurrency icon imports and provides a mapping
 * from coin symbols to their respective icons.
 */

// Static imports for all supported cryptocurrency icons
import Bitcoin from "cryptocurrency-icons/svg/color/btc.svg";
import Ethereum from "cryptocurrency-icons/svg/color/eth.svg";
import Ripple from "cryptocurrency-icons/svg/color/xrp.svg";
import Solana from "cryptocurrency-icons/svg/color/sol.svg";
import Dogecoin from "cryptocurrency-icons/svg/color/doge.svg";
import Cardano from "cryptocurrency-icons/svg/color/ada.svg";
import Avalanche from "cryptocurrency-icons/svg/color/avax.svg";

/**
 * Icon mapping object
 * Maps cryptocurrency symbols (uppercase) to their imported SVG icons
 */
export const iconMap = {
  BTC: Bitcoin,
  ETH: Ethereum,
  XRP: Ripple,
  SOL: Solana,
  DOGE: Dogecoin,
  ADA: Cardano,
  AVAX: Avalanche
};

/**
 * Get icon for a specific cryptocurrency symbol
 * @param {string} symbol - The cryptocurrency symbol (e.g., 'BTC')
 * @returns {string|null} The icon SVG path or null if not found
 */
export const getIcon = (symbol) => {
  return iconMap[symbol.toUpperCase()] || null;
};

/**
 * Check if an icon exists for a given symbol
 * @param {string} symbol - The cryptocurrency symbol
 * @returns {boolean} True if icon exists, false otherwise
 */
export const hasIcon = (symbol) => {
  return symbol.toUpperCase() in iconMap;
};

/**
 * Get all available cryptocurrency symbols that have icons
 * @returns {string[]} Array of symbols with available icons
 */
export const getAvailableSymbols = () => {
  return Object.keys(iconMap);
};

export default iconMap;